import type { BuildingDto, CreateBuildingDto, GetBuildingListDto, UpdateBuildingDto } from './models';
import { RestService } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TenantBuildingsService {
  apiName = 'Default';
  

  create = (input: CreateBuildingDto) =>
    this.restService.request<any, BuildingDto>({
      method: 'POST',
      url: '/api/app/tenant-buildings',
      body: input,
    },
    { apiName: this.apiName });
  

  delete = (id: string) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/app/tenant-buildings/${id}`,
    },
    { apiName: this.apiName });
  

  get = (id: string) =>
    this.restService.request<any, BuildingDto>({
      method: 'GET',
      url: `/api/app/tenant-buildings/${id}`,
    },
    { apiName: this.apiName });
  

  getList = (input: GetBuildingListDto) =>
    this.restService.request<any, PagedResultDto<BuildingDto>>({
      method: 'GET',
      url: '/api/app/tenant-buildings',
      params: { filter: input.filter, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName });
  

  update = (id: string, input: UpdateBuildingDto) =>
    this.restService.request<any, void>({
      method: 'PUT',
      url: `/api/app/tenant-buildings/${id}`,
      body: input,
    },
    { apiName: this.apiName });

  constructor(private restService: RestService) {}
}
